/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFaxProfileStatusDto
 */
export interface UpdateFaxProfileStatusDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateFaxProfileStatusDto
     */
    status: UpdateFaxProfileStatusDtoStatusEnum;
}


/**
 * @export
 */
export const UpdateFaxProfileStatusDtoStatusEnum = {
    Active: 'active',
    Suspended: 'suspended',
    Retired: 'retired'
} as const;
export type UpdateFaxProfileStatusDtoStatusEnum = typeof UpdateFaxProfileStatusDtoStatusEnum[keyof typeof UpdateFaxProfileStatusDtoStatusEnum];


/**
 * Check if a given object implements the UpdateFaxProfileStatusDto interface.
 */
export function instanceOfUpdateFaxProfileStatusDto(value: object): value is UpdateFaxProfileStatusDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateFaxProfileStatusDtoFromJSON(json: any): UpdateFaxProfileStatusDto {
    return UpdateFaxProfileStatusDtoFromJSONTyped(json, false);
}

export function UpdateFaxProfileStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFaxProfileStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function UpdateFaxProfileStatusDtoToJSON(json: any): UpdateFaxProfileStatusDto {
    return UpdateFaxProfileStatusDtoToJSONTyped(json, false);
}

export function UpdateFaxProfileStatusDtoToJSONTyped(value?: UpdateFaxProfileStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

